// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"InfoMenu_expandIcon__1QE3T","menu":"InfoMenu_menu__1V9vq","link":"InfoMenu_link__33s5y","icon":"InfoMenu_icon__3Xsvf"};